import styled from 'styled-components/macro'
import { Form } from 'react-bootstrap'
import palette from 'src/designSystem/variables/palette'

export const StyledSwitch = styled(Form.Switch)`
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;

  .form-check-input {
    transition: none !important;
    border-color: transparent !important;
    background-color: ${palette.neutral[100]} !important;
    margin: 0 !important;
    padding: 0 !important;
    transition: none !important;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3ccircle cx='10' cy='10' r='8' fill='gray' stroke='none' stroke-width='0.5'/%3e%3c/svg%3e") !important;

    &:hover,
    &:focus,
    &:focus-visible,
    &:active {
      border-color: transparent !important;
      background-color: ${palette.neutral[100]} !important;
      box-shadow: none !important;
      outline: none !important;
      cursor: pointer;
    }

    &:checked,
    &:checked:hover,
    &:checked:focus,
    &:checked:focus-visible,
    &:checked:active {
      background-color: ${palette.neutral[800]} !important;
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3ccircle cx='10' cy='10' r='8' fill='white' stroke='none' stroke-width='0.5'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='1' d='m7 10 2 2 4-4'/%3e%3c/svg%3e") !important;
      border-color: transparent !important;
      box-shadow: none !important;
      outline: none !important;
      cursor: pointer;
    }

    // Keyboard focus only (mouse clicks stay unringed). Declared after the
    // rules above, at the same specificity, so it overrides their outline: none.
    &:focus-visible,
    &:checked:focus-visible {
      outline: 2px solid ${palette.blue[500]} !important;
      outline-offset: 2px;
    }

    &:disabled {
      opacity: 0.4 !important;
      cursor: not-allowed !important;
    }
  }
`
